module.exports = __webpack_public_path__ + "img/fact_check.ce41d285.svg";